"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAuthTokens = exports.save = exports.removeAuthTokens = exports.remove = exports.load = exports.getAccessToken = void 0;
var _cookies = require("@kiwicom/cookies");
var _client = require("../platform/client");
const save = token => (0, _cookies.save)(_cookies.Cookie.UA_SESSION_TOKEN, token);
exports.save = save;
const saveAuthTokens = token => {
  const {
    accessToken,
    refreshToken
  } = token;
  (0, _cookies.save)(_cookies.Cookie.SU_ACCESS_TOKEN, accessToken);
  if (!(0, _client.isWebview)() && refreshToken) {
    (0, _cookies.save)(_cookies.Cookie.SU_REFRESH_TOKEN, refreshToken);
  }
};

/**
 * @deprecated Use getAccessToken from auth, or useGetAccessToken from auth context instead
 */
exports.saveAuthTokens = saveAuthTokens;
const load = () => (0, _cookies.load)(_cookies.Cookie.UA_SESSION_TOKEN);
exports.load = load;
const remove = () => (0, _cookies.remove)(_cookies.Cookie.UA_SESSION_TOKEN);
exports.remove = remove;
const removeAuthTokens = () => {
  (0, _cookies.remove)(_cookies.Cookie.SU_ACCESS_TOKEN);
  (0, _cookies.remove)(_cookies.Cookie.SU_REFRESH_TOKEN);
};

/**
 * @deprecated, it's not allowed to take access token directly from cookies anymore.
 * Please use getAccessToken from auth, or useGetAccessToken from auth context instead
 */
exports.removeAuthTokens = removeAuthTokens;
const getAccessToken = () => (0, _cookies.load)(_cookies.Cookie.UA_SESSION_TOKEN);
exports.getAccessToken = getAccessToken;